import axios from 'axios';
import { config } from '../../Configs';

export const GetFeesAPI = async (contractId, authToken) => {
  try {
    const response = await axios.get(`${config.api.url}/fees/${contractId}`, {
      headers: { Authorization: authToken }
    });

    return { success: true, data: response.data.data };
  } catch (err) {
    return { success: false, error: err };
  }
};
